import { createFeatureSelector, createSelector } from "@ngrx/store";
import { NccManageState } from "./reducers-ncc";

/**
 * Top level selector for the NccManageState
 */
export const nccManageState = createFeatureSelector<NccManageState>('nccsManage');

export const getFoundNccs = createSelector(
    nccManageState,
    (state: NccManageState) => state.entityData
);

export const getNccToEdit = createSelector(
    nccManageState,
    (state: NccManageState) => state.editEntityData
);

export const getNccToView = createSelector(
    nccManageState,
    (state: NccManageState) => state.viewEntityData
);

export const getNccCopyMode = createSelector(
    nccManageState,
    (state: NccManageState) => state.isCopy
);